import { useState } from 'react';
import MigrationItemViewDTO from '@src/adapters/dto/migration/MigrationItemViewDTO';
import MigrationSuggestionDTO from '@src/adapters/dto/migration/MigrationSuggestionDTO';
import { MigrationItemSuggestionStatus } from '@src/constants/MigrationItemSuggestionStatus';
import Suggestions from './suggestions/Suggestions';
import CardItems from './components/CardItems';
import MigrationItemUpdateDTO from '@src/adapters/dto/migration/MigrationItemUpdateDTO';
import MigrationDetailDTO from '@src/adapters/dto/migration/MigrationDetailDTO';
import { MigrationStatus } from '@src/constants/MigrationStatus';

interface Props {
  migration: MigrationDetailDTO;
  suggestions: MigrationSuggestionDTO[];
  items: MigrationItemViewDTO[];
  highlightItem(suggestionId?: string): void;
  deleteItem(itemId?: string): void;
  itemUpdated(item: MigrationItemUpdateDTO): void;
  suggestionUpdate(
    suggestion: MigrationSuggestionDTO,
    status: MigrationItemSuggestionStatus,
    inventoryId?: string,
    qtyOpen?: number,
    qtyOnHand?: number,
    note?: string,
    alias?: Boolean,
    isLoan?: boolean
  ): void;
  refreshSuggestions(): void;
  inventoryItemAdded(item: MigrationItemViewDTO): void;
  handleItemApprovalUpdate(
    itemId: string,
    suggestionId: string | undefined,
    approved: boolean
  ): void;
}

function ContentsTab({
  migration,
  suggestions,
  items,
  highlightItem,
  deleteItem,
  itemUpdated,
  suggestionUpdate,
  refreshSuggestions,
  inventoryItemAdded,
  handleItemApprovalUpdate,
}: Props) {
  const [highlightedId, setHighlightedId] = useState<string>();
  const [lockView, setLockView] = useState(false);

  const handleSuggestionSelected = (id: string) => {
    setLockView(true);
    highlightItem(id);
    setHighlightedId(undefined);
  };

  const handleSelectionCleared = () => {
    setLockView(false);
  };

  const handleItemSelected = (id: string) => {
    highlightItem(id);
    setHighlightedId(id);
  };

  const handleRefeshSuggestions = () => {
    highlightItem();
    refreshSuggestions();
  };

  return (
    <>
      {migration.status !== MigrationStatus.Complete && (
        <Suggestions
          refreshSuggestions={handleRefeshSuggestions}
          suggestionUpdate={suggestionUpdate}
          suggestions={suggestions}
          highlightItem={handleSuggestionSelected}
          selectionCleared={handleSelectionCleared}
        />
      )}
      <CardItems
        items={items}
        migration={migration}
        deleteItem={deleteItem}
        itemUpdated={itemUpdated}
        highlightItem={handleItemSelected}
        inventoryItemAdded={inventoryItemAdded}
        highlightedId={highlightedId}
        lockView={lockView}
        handleItemApprovalUpdate={handleItemApprovalUpdate}
      />
    </>
  );
}

export default ContentsTab;
